import React from 'react'

const FeeStructure = () => {
  return (
    <div>
    <h1>admission fee for levelOne</h1>
    <hr />
    <p>levelZero is the starting point of this boot camp for programming. It is:</p>

    <ol>
        <li>
            <ul>
                <li>Before we begin, remember that this fee is only for the closed and advanced level i.e. levelOne. The basic level is free and open for all and it will teach you enough to get started with your programming journey.</li>
                <li>The primary fee and criteria are your hard work and commitment. The reason behind bringing a free, beginner-friendly levelZero was to not make money but to ignite your love for programming.</li>
                <li>The monetary fee for the 6-month course of levelOne will be INR 30,000 + 18% GST + a convenience fee may be charged by the payment gateway you choose to pay with. But, this will be payable only after you are qualified for admission.</li>
                <li>Keeping in mind our aim to make money only an enabler and not the primary barrier to your success, we have reserved seats for financial aid for the applicants from a family with a monthly income of less than Rs. 50,000 and who are eligible to join a job in June 2023. We also have an EMI payment option for the ones who need it.</li>
                <p>Financial aid for the ones who need it: At the same time, we are not ignorant of the fact that there are families in the world for whom this would be a lot. If your family feels that and anybody whose house income is less than Rs. 50k per month can apply for financial aid. Money should always be an enabler and not a blocker of your success. (Read more about the financial aid here)</p>
            </ul>
        </li>
    </ol>
</div>
  )
}

export default FeeStructure